import { IEntity } from "@interfaces/entity";
import { ChargingStation } from "./charging-station";
import { Customer } from "./customer";
import { Address } from "./address";
import { EnergyMeter } from "./energyMeter";
import { ChargingPointSignalColorDto } from "@dto/ChargingPointSignalColorDto";

export class Blackbox implements IEntity {
  id: number;
  serialNumber: string;

  customerId: number;
  customer: Customer;

  addressId: number;
  address: Address;

  chargingStations: ChargingStation[];
  energyMeters: EnergyMeter[];
  chargingPointSignalColors: ChargingPointSignalColorDto[];

  isDeleted: boolean;

  entityName = "Blackbox";

  constructor(formValue?: Partial<Blackbox>) {
    Object.assign(this, formValue);
  }

  updateValues(formValue: Partial<Blackbox>) {
    Object.assign(this, formValue);
  }

  getPrimaryKey() {
    return this.id;
  }
}
